/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, November 5th 2021, 8:51:08 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { OSForm, RelatedObjectOSFormProps, TextFormInput, Typography } from "ui-widgets";
import { Department, DepartmentValidationSchema, newDepartmentDefault } from "lib/schemas";
import { ValidationResolver } from "lib/validation";
import { useForm } from "react-hook-form";
import { WorkersTransferListInput } from "workers";

interface DepartmentFormProps extends RelatedObjectOSFormProps<Department> {
  showAddWorkers?: boolean;
}

export const DepartmentForm = (props: DepartmentFormProps) => {
  const { defaultItemValue = newDepartmentDefault, showAddWorkers = true } = props;

  const useFormReturn = useForm<any>({
    defaultValues: defaultItemValue,
    mode: "onTouched",
    resolver: ValidationResolver(DepartmentValidationSchema),
  });

  return (
    <React.Fragment>
      <Typography variant="h6" className="os-content-description">
        Provide the basic information about the department
      </Typography>

      <OSForm
        onFormSubmit={useFormReturn.handleSubmit(props.handleValidForm)}
        validationSchema={DepartmentValidationSchema}
        useFormReturn={useFormReturn}
        onFormCancel={props.onFormCancel}
      >
        <TextFormInput<Department> schema_field_key="name" label="Name" />
        {showAddWorkers ? (
          <WorkersTransferListInput<Department> label="Add users to this department" schema_field_key="workers" />
        ) : null}
      </OSForm>
    </React.Fragment>
  );
};
